import React from 'react';
import { Popover } from 'antd';
import { TPaymentBilling } from 'types/provider';
import useInvoiceDetail from 'hooks/useInvoiceDetail';
import s from './s.module.less';

interface InvoiceLabelProps {
    record: TPaymentBilling;
}

const InvoiceLabel: React.FC<InvoiceLabelProps> = ({ record }) => {
    // Get line items count
    const lineItemsCount = record.lineItems?.length || 0;
    const hasLineItems = lineItemsCount > 0;
    const lineItemText = lineItemsCount === 1 ? 'line item' : 'line items';

    // Render popover content with line items
    const renderLineItemsContent = () => {

        const lineItems = record.lineItems || [];
        if (lineItems.length === 0) {
            return <div className={s.emptyText}>No line items.</div>;
        }

        return (
            <div className={s.lineItemsPopover}>
                {lineItems.map((item, index) => (
                    <div key={item.id} className={s.lineItemRow}>
                        <div className={s.lineItemLeft}>
                            <div className={s.lineItemTitle}>Line item {index + 1}</div>
                            <div className={s.lineItemDescription}>{item.description}</div>
                        </div>
                        <div className={s.lineItemRight}>
                            ${(item.amount || 0).toFixed(2)}
                        </div>
                    </div>
                ))}
            </div>
        );
    };


    const labelContent = (
        <div className={s.invoiceLabel}>
            {hasLineItems ? (
                <>
                    <div className={s.lineItemCount}>
                        {lineItemText}
                    </div>
                    <div className={s.invoiceNumber}>
                        Invoice {record.invoiceNo}
                    </div>
                </>
            ) : (
                <div className={s.invoiceNumberOnly}>
                    Invoice {record.invoiceNo}
                </div>
            )}
        </div>
    );

    return (
        <>
            {hasLineItems ? (
                <Popover
                    content={renderLineItemsContent()}
                    trigger="hover"
                    placement="right"
                    overlayClassName={s.invoiceLabelPopover}
                >
                    {labelContent}
                </Popover>
            ) : (
                labelContent
            )}
        </>
    );
};

export default InvoiceLabel;
